import React from "react";
import { Row, Col } from "reactstrap";

function AmazonProductListingSummaryBar({ summary}) {
  if (!summary) return null;

  const items = [
    { key: "total_fields", label: "Total Fields" },
    { key: "filled_fields", label: "Filled" },
    { key: "missing_fields", label: "Missing" },
    { key: "mandatory_fields", label: "Mandatory" },
    { key: "errors", label: "Errors" },
    { key: "warnings", label: "Warnings" },
    { key: "valid", label: "Valid" },
  ];

  return (
    <div className="summary-bar-container">
      <Row className="g-2 flex-nowrap m-0">
        {items.map(function (item) {
          let val = summary[item.key];
          if (val === undefined || val === null) val = 0;

          return (
            <Col className="flex-fill summary-col px-1" key={item.key}>
              
              <div className={`summary-card text-center card-${item.key}`}>
                
                <div className="summary-value fw-bold fs-5">
                  {val}
                </div>

                <div className="summary-label fw-bold">
                  {item.label}
                </div>
                
              </div>

            </Col>
          );
        })}
      </Row>
    </div>
  );
}

export default AmazonProductListingSummaryBar;